import * as React from 'react';
import StorageService from '../services/StorageService';
import { API_CACHE_KEYS } from '../services/lib/APIServiceInterfaces';
import appStore from '../AppStore';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import GQLoader from './GQLoader/GQLoader';

const Impersonate = React.memo(() => {
    const { token } = useParams();
    useEffect(() => {
        // TODO: won't work with new fitch auth
        StorageService.set(API_CACHE_KEYS.IMPERSONATE, true);
        appStore.setImpersonate(true);
        window.location.href = '/';
    }, [token]);

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
            }}>
            <GQLoader />
            Loading impersonated user
        </div>
    );
});

export default Impersonate;
